import { FC, ReactNode } from 'react';
import * as S from './styles';

type ReactComponent = FC<{ children?: ReactNode }>;

const Section: ReactComponent & { Content: typeof S.Content } = props => {
  return <S.Section {...props} />;
};

Section.Content = S.Content;

export default Section;
